module.exports = __webpack_public_path__ + "img/banner1.905d5552.png";